import { render } from "./SpeciesDiscovered.vue?vue&type=template&id=9513d384&scoped=true"
import script from "./SpeciesDiscovered.vue?vue&type=script&lang=js"
export * from "./SpeciesDiscovered.vue?vue&type=script&lang=js"

import "./SpeciesDiscovered.vue?vue&type=style&index=0&id=9513d384&scoped=true&lang=css"

import exportComponent from "/home/acartia-ops/acartia/src/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9513d384"]])

export default __exports__